"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var preact_1 = require("preact");
var compat_1 = require("preact/compat");
var Overlay_1 = require("./Overlay");
var BaseModal_1 = require("./BaseModal");
var ModalWrapper = function (_a) {
    var children = _a.children, open = _a.open, setOpen = _a.setOpen, onClickOverlay = _a.onClickOverlay;
    return ((0, preact_1.h)(preact_1.Fragment, null,
        (0, preact_1.h)(Overlay_1.default, { open: open, closeFn: function () {
                setOpen(function () { return false; });
                onClickOverlay && onClickOverlay();
            } }),
        (0, preact_1.h)(BaseModal_1.default, { open: open }, children)));
};
exports.default = (0, compat_1.memo)(ModalWrapper);
